<template>
  <div
    ref="rootRef"
    class="relative -mb-4 md:h-auto"
    :class="isCollapsed ? 'h-124 md:h-auto' : 'h-auto'"
  >
    <div class="absolute inset-x-0 -top-10 flex justify-center">
      <SvgScribble class="mx-[-20vw] h-auto text-black/5" />
    </div>
    <div
      ref="innerRef"
      class="relative z-2 space-y-[2em] overflow-hidden rounded-xs bg-white p-8 text-[14px]/[1.3em] shadow-md md:mb-0 md:px-14 md:py-10"
    >
      <img
        class="mx-auto w-2/3 md:w-[260px]"
        src="/img/sa/sa-premier-masthead.png"
        alt="Premier Masthead"
      />
      <div class="space-y-[1em]">
        <PayloadRichText :content="props.content" />
      </div>
      <div class="text-[8px]/[1.3em] md:text-[14px]">
        <img
          class="mb-[-1em] w-[10em]"
          src="/img/sa/sa-premier-signature.png"
          alt="Signature"
        />
        <cite>
          Peter Malinauskas
          <br />
          <strong class="font-medium">PREMIER</strong>
        </cite>
      </div>
      <div
        class="pointer-events-none absolute inset-x-0 bottom-0 z-2 h-20 bg-linear-to-t from-black/5 to-transparent"
      />
    </div>
    <Transition name="fade">
      <div
        v-if="isCollapsed"
        class="absolute inset-x-0 bottom-0 z-2 flex h-96 items-end justify-center bg-linear-to-t from-white to-transparent pb-12 md:hidden"
      >
        <BaseButton
          v-track-click="{
            cta_name: 'view_full_letter',
            cta_location: 'sa_landing',
          }"
          class="btn-md btn-yellow relative z-2"
          @click="onClick"
          >View full letter</BaseButton
        >
        <div
          class="pointer-events-none absolute inset-x-0 bottom-0 z-2 h-20 bg-linear-to-t from-black/5 to-transparent"
        />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
interface Props {
  content: any
}

const props = defineProps<Props>()

const { $anime } = useNuxtApp()
const rootRef = useTemplateRef('rootRef')
const innerRef = useTemplateRef('innerRef')
const isCollapsed = ref(true)

const onClick = () => {
  if (!rootRef.value || !innerRef.value) return

  $anime({
    targets: rootRef.value,
    height: [rootRef.value.clientHeight, innerRef.value.clientHeight],
    duration: 750,
    easing: 'easeInOutQuad',
    begin() {
      isCollapsed.value = false
    },
    complete() {
      if (innerRef.value) {
        innerRef.value.style.height = ''
      }
    },
  })
}
</script>

<style scoped>
@reference "#css";

.fade-enter-active,
.fade-leave-active {
  @apply transition-opacity duration-200;
}

.fade-enter-from,
.fade-leave-to {
  @apply opacity-0;
}
</style>
